// Burger menu js starts
$(".hamburger").on("click", function () {
    $(this).toggleClass("hamburger-style");
    $(".nav").toggleClass("nav-active");
    $("body").toggleClass("body_noScroll");
});

// const hamBurger=document.querySelector('.hamburger');
// const aNav=document.querySelector('.nav');
// const aBody=document.querySelector('body');
//     hamBurger.addEventListener('click',()=>{
//         this.classList.toggle("hamburger-style");
//         aNav.classList.toggle("nav-active");
//         aBody.classList.toggle("body_noScroll");
//     });

document.addEventListener("DOMContentLoaded", function () {
    window.addEventListener("scroll", function () {
        const header = document.querySelector(".header");
        if (header) {
            header.classList.toggle("nav_dark", window.scrollY > 100);
        }
    });
});

$("#testimonial-carousel").owlCarousel({
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    autoplay: true,
    smartSpeed: 1300,
    navText: [
        '<i class="fa-solid fa-angle-left"></i>',
        '<i class="fa-solid fa-angle-right"></i>',
    ],
    autoplayTimeout: 40000,
    autoplayHoverPause: true,
    // animateOut: 'slideOutDown',
    // animateIn: 'flipinX',
    // slideTransition: linear,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 1,
        },
        1000: {
            items: 1,
        },
    },
});

// snapMixin = Swal.mixin({
//     toast: true,
//     icon: 'success',
//     // title: 'Welcome to Snap Club',
//     // animation: true,
//     position: 'bottom-right',
//     showConfirmButton: false,
//     confirmButtonColor: '#3085d6',
//     cancelButtonColor: '#d33',
//     customClass: {
//         confirmButton: 'btn-fill',
//         cancelButton: 'btn-fill'
//     },
//     buttonsStyling: false,
//     timer: 5000,
//     timerProgressBar: true,
//     didOpen: (toast) => {
//         toast.addEventListener('mouseenter', Swal.stopTimer)
//         // toast.addEventListener('mouseover', Swal.increaseTimer(3000-Swal.getTimerLeft()))
//         toast.addEventListener('mouseleave', Swal.resumeTimer)
//     }
// });

// snapMixin = Swal.mixin({
//     toast: true,
//     icon: 'success',
//     // title: 'Welcome to Snap Club',
//     // animation: true,
//     position: 'bottom-right',
//     showConfirmButton: false,
//     confirmButtonColor: '#3085d6',
//     cancelButtonColor: '#d33',
//     customClass: {
//         confirmButton: 'btn-fill',
//         cancelButton: 'btn-fill',
//         denyButton: 'btn-fill'
//     },
//     buttonsStyling: false,
//     timer: 5000,
//     timerProgressBar: true,
//     didOpen: (toast) => {
//         toast.addEventListener('mouseenter', Swal.stopTimer)
//         // toast.addEventListener('mouseover', Swal.increaseTimer(3000-Swal.getTimerLeft()))
//         toast.addEventListener('mouseleave', Swal.resumeTimer)
//     }
// });

// $('.modal').modal({
//     keyboard: false
// });

$("#home-carousel").owlCarousel({
    stagePadding: 50,
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    autoplay: true,
    smartSpeed: 1300,
    navText: [
        '<i class="fa-solid fa-angle-left"></i>',
        '<i class="fa-solid fa-angle-right"></i>',
    ],
    autoplayTimeout: 40000,
    autoplayHoverPause: true,
    // animateOut: 'slideOutDown',
    // animateIn: 'flipinX',
    // slideTransition: linear,
    responsive: {
        0: {
            items: 1,
        },
        600: {
            items: 1,
        },
        1000: {
            items: 1,
        },
    },
});
